<app-breadcrumb></app-breadcrumb>
<div class="container">
  <div class="row">
    <div class="col-lg-7 ml-4">

      <div class="input-group mb-3">
        <!-- <input
        type="search"
        class="form-control"
        placeholder="Search"
        [(ngModel)]="searchInput"
        [matAutocomplete]="auto"
        (input)="onInputChange()"
        /> -->
        <!-- <div class="input-group-prepend">
        <i class="input-group-text fas fa-search" id="basic-addon1" (click)="search()"></i>
      </div> -->
    </div>

    <mat-autocomplete #auto="matAutocomplete">
      @for (option of options; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>

    <div class="search-header-row">
      @if (isSearchInput) {
        <h2 style="color: #7A7A7A;">
          Showing Result for: <strong class="highlighted-match">{{ searchInput }}</strong>
        </h2>
      } @else {
        <h2>Recent Searches (right below searchbar)</h2>
      }
      @if (!isSearching) {
        <div class="all-results">All results ({{ length }})</div>
      }
    </div>





    <div class="mt-1 accord">
      @if (searchInput.length >= 3 && isSearching) {
        <div class="searching-container">
          <div class="searching-content">
            <div class="spinner"></div>
            <h3 class="searching-title">Searching...</h3>
            <p class="searching-message">Please wait while we find your results</p>
          </div>
        </div>
      }

      @if (!isSearching && paginatedResults.length > 0) {
        <mat-accordion>
          @for (search of paginatedResults; track search) {
            <div>
              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title [innerHTML]="highlightSearchText(search.item, searchInput)"></mat-panel-title>
                  @if (search.module) {
                    <mat-panel-description>
                      {{ search.module }}
                    </mat-panel-description>
                  }
                </mat-expansion-panel-header>
                @if (getModuleFields(search.module); as fields) {
                  <div>
                    @for (field of fields; track field) {
                      @if (search.data[field.key]) {
                        <p style="color: #555;font-size: 16px;font-weight: 500;">
                          {{ field.label }}:
                          @if (field.key === 'assessment_plan_start_datetime' || field.key === 'assessment_plan_end_datetime') {
                            <span
                              >
                              {{ convertToIST(search.data[field.key]) }}
                            </span>
                          }
                          @if (field.key !== 'assessment_plan_start_datetime' && field.key !== 'assessment_plan_end_datetime') {
                            <span
                              >
                              {{ formatSearchFieldValue(field, search.data[field.key]) }}
                            </span>
                          }
                        </p>
                      }
                    }
                    @if (getModuleRouterCommands(search.module); as moduleLinkCommands) {
                      <p>
                        <a [routerLink]="moduleLinkCommands">
                          Go to {{ getNormalizedModuleName(search.module) }}
                        </a>
                      </p>
                    }
                  </div>
                }
              </mat-expansion-panel>
            </div>
          }
        </mat-accordion>
      } @else {
        @if (!isSearching && searchInput.length >= 3) {
          <div class="no-results-container">
            <div class="no-results-content">
              <h3 class="no-results-title">No results found</h3>
            </div>
          </div>
        }
      }


      @if (!isSearching && paginatedResults.length > 0) {
        <div class="custom-paginator">
          <button class="nav-btn" [disabled]="pageIndex === 0" (click)="previousPage()">
            <i class="fa-solid fa-arrow-left" style="font-size: 30px;"></i>
          </button>
          <div class="page-info">
            <span>Items per page:</span>
            <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
              @for (option of [5, 10, 25]; track option) {
                <option [value]="option">{{ option }}</option>
              }
            </select>
          </div>
          <div class="range-info" style="margin-right: 40px;">
            {{ getStartIndex() + 1 }}–{{ getEndIndex() }} of {{ length }}
          </div>
          <button class="nav-btn" [disabled]="getEndIndex() >= length" (click)="nextPage()">
            <i class="fa-solid fa-arrow-right" style="font-size: 30px;"></i>
          </button>
        </div>
      }
    </div>
  </div>
  <div class="col-lg-4 mt-2">
    <!--<div class="box-search">
    <div class="font-weight-bold">On this page</div>

    <div class="pr-3 mt-3">
      <div *ngFor="let item of tags | keyvalue : orderOriginal; let index = i" class="ml-2">
        <div class="mb-3">
          {{ item.key }} ({{ item.value }})
        </div>
      </div>
    </div>

  </div>-->
  <div class="recent-header-row" style="margin-top: 4px;">
    <h2 style="color: #7A7A7A;font-weight: 600;">
      Recent Searches
    </h2>
  </div>

  <div class="box-search mt-2">
    <div class="pr-3 mt-3">
      @for (search of getDisplayedRecentSearches(); track search) {
        <div
          class="recent-item cursor-pointer"
          (click)="onRecentSearchClick(search.item)">
          <mat-icon class="recent-search-icon">search</mat-icon>
          <span class="recent-text">{{ formatRecentSearchLabel(search) }}</span>
          <button type="button"
            class="recent-search-delete"
            (click)="removeRecentSearch(search, $event)"
            aria-label="Remove recent search">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
      <div class="see-more-wrapper">
        <button class="btn btn-link see-more-btn"
          (click)="toggleRecentSearches()" >
          {{ showAllRecentSearches ? 'Show Less' : 'See More' }}
        </button>
      </div>
    </div>
  </div>
</div>
</div>
</div>
